import { Phase } from "../../../../util/enums";

const generateLeftAndRightPositionDistance = (angleInDegrees: number, isAvatarCheering: boolean, game: any): { bottom_position_of_profile_box: string, left_position_of_profile_box: string } => {


    const angleInRadians = angleInDegrees * Math.PI / 180.1;
    const halfOfTheInputAngle = angleInRadians / 2
    let ratioForTheDstanceNeededToBringProfileCloserToTheAvatar: number = Math.cos(2*halfOfTheInputAngle);
    let moveAvatarsFurther = false;

    if(isAvatarCheering || game.phase === Phase.CHOOSING_SOLUTION_CARDS){
        moveAvatarsFurther = true;
    }

    let bottom_position_of_profile_box = moveAvatarsFurther ? "-45px" : "-25px";
    let left_position_of_profile_box = moveAvatarsFurther ? "-90px" : "-80px";

    if ( Math.sin(angleInDegrees) === 0 && game?.players.length > 5) {
        bottom_position_of_profile_box = "-2vw";
        left_position_of_profile_box = "-3vw";
        return { bottom_position_of_profile_box, left_position_of_profile_box };
    }

    if (ratioForTheDstanceNeededToBringProfileCloserToTheAvatar > 0.998) {
        bottom_position_of_profile_box = moveAvatarsFurther ? `260px` : `210px`;
        left_position_of_profile_box = "-2vw";
    }

    if (ratioForTheDstanceNeededToBringProfileCloserToTheAvatar < -0.998) {
        bottom_position_of_profile_box = moveAvatarsFurther ? `-100px` : `-70px`;
        left_position_of_profile_box = "-80px";
    }

    return { bottom_position_of_profile_box, left_position_of_profile_box };
}

export default generateLeftAndRightPositionDistance;